import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

export const FormGroupEmail = ({ email, onChange }) => {
  return (
    <div className="form-group">
      <input
        type="email"
        id="email"
        name="email"
        value={email}
        onChange={onChange}
        required
        autoComplete="email"
        inputMode="email"
        placeholder=" "
      />
      <label htmlFor="email">Email</label>
    </div>
  );
};

FormGroupEmail.propTypes = {
  email: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
